import { useUnit } from 'effector-react'
import { Form } from 'react-aria-components'

import { css } from '@portal/styled-system/css'

import { ForgotPasswordButton } from '@/features/password-reset'
import { useI18n } from '@/shared/lib/i18n'
import { Button, ErrorMessage } from '@/shared/ui'

import { EmailInputField, PasswordInputField } from '../input-field'
import * as model from '../model'

export function LoginFormBody() {
    const { i18n } = useI18n()

    const loginFormSubmitted = useUnit(model.loginFormSubmitted)
    const errorMessage = useUnit(model.$loginErrorMessage)
    const loginValidationError = useUnit(model.$loginValidationError)

    const nonInteractive = useUnit(model.$interactionDisabled)

    const handleFormSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault()

        loginFormSubmitted()
    }

    return (
        <Form
            method="post"
            onSubmit={handleFormSubmit}
            className={css({ display: 'flex', flexDirection: 'column', gap: '2' })}
        >
            <EmailInputField
                placeholder={i18n.USER_EMAIL}
                autoComplete="username"
                isDisabled={nonInteractive}
                isError={Boolean(loginValidationError)}
                description={loginValidationError}
            />
            <PasswordInput />

            <Button color="primary" type="submit" isDisabled={nonInteractive}>
                {i18n.BUTTON_LOGIN}
            </Button>

            {errorMessage && (
                <ErrorMessage styles={{ textAlign: 'center', paddingTop: '1' }}>{errorMessage}</ErrorMessage>
            )}
        </Form>
    )
}

function PasswordInput() {
    const { i18n } = useI18n()

    const nonInteractive = useUnit(model.$interactionDisabled)

    return (
        <PasswordInputField
            name="password"
            placeholder={i18n.USER_PASSWORD}
            autoComplete="current-password"
            required
            isDisabled={nonInteractive}
            descriptionRight={<ForgotPasswordButton />}
        />
    )
}
